/**
 * Language English
 */

export default {
    ID_SETTING_CONFIRM_DIALOG_TITLE: "Clean up the cache?",
};
